import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {replacePill} from 'src/components/criteria-strip';
import {MAX_SELECTED_ACCOUNTS} from 'src/constants';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';


type Props = {
    accountIds: number[],

    showAddToAccountTeam: boolean,
    openAddToAccountTeamTool: () => void,

    showSetAccountStatus: boolean,
    openSetAccountStatusTool: () => void,

    showUpdateLicense: boolean,
    openEnableModuleAccessPermissionsTool: () => void,
    openDisableModuleAccessPermissionsTool: () => void,
};

export const ToolsMenu = (props: Props) => {
    const dispatch = useDispatch();
    const {accountIds} = props;

    const onAddToCriteria = useCallback(() => {
        dispatch(replacePill({
            propName: 'accountIds',
            pill: accountIds.map(value => ({value})),
        }));
    }, [accountIds, dispatch]);

    return (
        <DropdownMenu
            anchor={({positionRef, getAnchorProps, anchorRef}) => (
                <FlatButton
                    endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                    {...getAnchorProps()}
                    ref={anchorRef}>
                    <b>Bulk Actions</b>
                </FlatButton>
            )}>
            <DropdownMenuItem
                title={accountIds.length > MAX_SELECTED_ACCOUNTS
                    ? `Max count of accounts for filtering is ${MAX_SELECTED_ACCOUNTS}`
                    : undefined}
                caption="Filter by Selected"
                onClick={onAddToCriteria}
            />
            {props.showAddToAccountTeam ? (
                <DropdownMenuItem
                    caption="Add To Account Team"
                    onClick={props.openAddToAccountTeamTool}
                />
            ) : null}
            {props.showSetAccountStatus ? (
                <DropdownMenuItem
                    caption="Set Account Status"
                    onClick={props.openSetAccountStatusTool}
                />
            ) : null}
            {props.showUpdateLicense ? (
                <DropdownMenuItem caption="Update License" iconAfter={Icons.ANGLE_RIGHT}>
                    <DropdownMenuItem
                        caption="Enable Module Access Permissions"
                        onClick={props.openEnableModuleAccessPermissionsTool}
                    />
                    <DropdownMenuItem
                        caption="Disable Module Access Permissions"
                        onClick={props.openDisableModuleAccessPermissionsTool}
                    />
                </DropdownMenuItem>
            ) : null}
        </DropdownMenu>
    );
};
